import { NavigationBar } from "./Navigationbar.jsx";
import { Stack } from "@mui/material";

export const PageLayout = (props) => {
    /**
     * Most applications will need to conditionally render certain components based on whether a user is signed in or not.
     * msal-react provides 2 easy ways to do this. AuthenticatedTemplate and UnauthenticatedTemplate components will
     * only render their children if a user is authenticated or unauthenticated, respectively.
     */
    return (
        <>
            <NavigationBar />
            <Stack
                direction={"column"}
                // justifyContent={"center"}
                alignItems={"center"}
                sx={{
                    minHeight: "40vh",
                }}
            >
                {props.children}
                {/* <Box sx={{ height: "100px" }}></Box> */}
            </Stack>
            {/* <BottomBar /> */}
        </>
    );
};
